<template>
  <div class="video-wrapper">
    <div class="video" v-for="cmp in componentList" :key="cmp.url">
      <YtPlayer v-if="cmp.name === 'youtube'" :url="cmp.url" />
      <VimeoPlayer v-if="cmp.name === 'vimeo'" :url="cmp.url" :autoHeight="autoHeight" />
      <IframeVideo v-if="cmp.name === 'iframe'" :url="cmp.url" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import YtPlayer from '@/components/ytPlayer/ytPlayer.vue'
  import IframeVideo from '@/components/iframeVideo/iframeVideo.vue'
  import VimeoPlayer from '@/components/vimeo/vimeo.vue';
  import brandingMixin from '@/mixins/branding'

  export default {
    mixins: [
      brandingMixin
    ],
    components: {
      YtPlayer,
      VimeoPlayer,
      IframeVideo
    },
    props: {
      autoHeight: { // only for vimeo
        default: false,
        type: Boolean
      },
      isTop: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      ...mapState('tours', ['video']),
      componentList () {
        const data = this.video

        if (!data) {
          return []
        }

        if (data.videos) {
          const result = data.videos.map(item => {
            return {
              name: item.name,
              url: this.isBranded ? item[item.name].branded : item[item.name].unbranded
            }
          })

          return this.isTop && result.length > 0 ? [result[0]] : result;
        } else if (data.isYoutube || data.isVimeo || data.isIframe) {
          const name = (data.isYoutube && 'youtube') || (data.isVimeo && 'vimeo') || (data.isIframe && 'iframe');

          return [{
            name,
            url: (data.isYoutube && (this.isBranded ? data.youtubeUrlBranded : data.youtubeUrlUnbranded )) 
            || (data.isVimeo && (this.isBranded ? data.vimeoUrlBranded : data.vimeoUrlUnbranded )) 
            || (data.isIframe && (this.isBranded ? data.iframeUrlBranded : data.iframeUrlUnbranded )) 
          }]
        } else {
          return []
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .video {
    margin-bottom: 40px;
  }
</style>
